export default __webpack_public_path__ + "static/grenette-bold-pro-848fa92b00f2905da3051e54e868051a.woff2";